// Gzip helpers on the platform's CompressionStream (every current browser, Node 18+, and Workers).

async function pipe(data: Uint8Array, stream: CompressionStream | DecompressionStream): Promise<Uint8Array> {
  const out = new Blob([data as BlobPart]).stream().pipeThrough(stream as unknown as ReadableWritablePair<Uint8Array, Uint8Array>);
  return new Uint8Array(await new Response(out).arrayBuffer());
}

export function gzip(data: string | Uint8Array): Promise<Uint8Array> {
  return pipe(typeof data === "string" ? new TextEncoder().encode(data) : data, new CompressionStream("gzip"));
}

export function gunzip(data: ArrayBuffer | Uint8Array): Promise<Uint8Array> {
  return pipe(data instanceof Uint8Array ? data : new Uint8Array(data), new DecompressionStream("gzip"));
}

export function gzipJson(value: unknown): Promise<Uint8Array> {
  return gzip(JSON.stringify(value));
}

export async function gunzipJson<T>(data: ArrayBuffer | Uint8Array): Promise<T> {
  return JSON.parse(new TextDecoder().decode(await gunzip(data))) as T;
}
